<header (click)="getHeaderLink()" class="sub-menu-v2--header">
    <label>{{ heading }}</label>
    <i class="icon-ic-chevron-s1"></i>
</header>
